import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { storePssSetCredential } from "../datasources/_pss.auth.store.slice";
import { useTypedSelector } from "../../../../store";
import { LogonResponse } from "../../../types/responses";

export const usePssRestoreAuthRepo = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(true);
  const accessToken = useTypedSelector(({ pssAuth }) => pssAuth.accessToken);

  useEffect(() => {
    const logonString =
      localStorage.getItem("PssLogon") ?? sessionStorage.getItem("PssLogon");

    if (!logonString) {
      setLoading(false);
      return;
    }
    try {
      const logon = JSON.parse(logonString) as LogonResponse;
      dispatch(storePssSetCredential(logon));
      setLoading(false);
    } catch (e) {
      return setLoading(false);
    }
  }, [dispatch]);
  return {
    state: {
      loading,
      isAuthenticated: accessToken ? true : false,
    },
  };
};
